import { COMPETITOR_RATING_EPSILON } from '@/core/components/reputation/competitor-map-pins';

export type CompetitorTheaterLabels = {
  limitation: string;
  /** Accessible name of the info button next to the data note. */
  limitationLabel: string;
  remove: string;
  limitReached: string;
  addError: string;
  rating: string;
  reviews: string;
  mapUnavailable: string;
  yourLocation: string;
  track: string;
  tracked: string;
  noCoordinates: string;
  unsupportedPreset: string;
  nearbyEmpty: string;
  nearbyError: string;
  radiusHint: string;
  radiusHintTracked: string;
  searchHeading: string;
  close: string;
  vsYou: string;
  vsYouEven: string;
  legendTracked: string;
  legendSuggested: string;
  youShort: string;
  legendThreat: string;
  legendAhead: string;
  legendEven: string;
  clusterCount: string;
  recenterMap: string;
  sampleReviews: string;
  removed: string;
  undo: string;
};

export function ratingDelta(
  placeRating: number | undefined,
  yourRating: number | undefined,
): number | null {
  if (placeRating == null || yourRating == null) return null;
  return Number((placeRating - yourRating).toFixed(1));
}

/** Chip copy: tied ratings say “same as you”, not a cryptic “0.0 vs you”. */
export function formatVsYouChip(
  delta: number,
  labels: Pick<CompetitorTheaterLabels, 'vsYou' | 'vsYouEven'>,
): string {
  if (Math.abs(delta) <= COMPETITOR_RATING_EPSILON) return labels.vsYouEven;
  const signed = `${delta > 0 ? '+' : ''}${delta.toFixed(1)}`;
  return labels.vsYou.replace('{delta}', signed);
}

export const springPanel = {
  type: 'spring' as const,
  stiffness: 380,
  damping: 32,
  mass: 0.85,
};
